// Shared by the event mapper, LINE delivery, and notification list.
// Review eligibility follows the process transition, not the booking-end clock.
const BOOKING_PROCESSES = new Set([
  'default-booking',
  'flex-default-process',
  'flex-hourly-default-process',
  'flex-booking-default-process',
  'promptpay',
  'mobile-banking',
]);
const BOOKING_COMPLETION_TRANSITIONS = new Set([
  'transition/complete',
  'transition/operator-complete',
  'transition/auto-complete-after-reschedule-booking',
  'transition/operator-complete-after-reschedule-booking',
]);
const REVIEW_PERIOD_START_TRANSITIONS = new Set([
  'transition/payout-complete',
  'transition/operator-payout-complete',
  'transition/payout-complete-after-dispute',
  'transition/operator-payout-complete-after-dispute',
  'transition/complete-after-cancel',
  'transition/operator-complete-after-cancel',
]);

const isBookingReviewProcess = transaction =>
  BOOKING_PROCESSES.has(String(transaction?.attributes?.processName || '').split('/')[0]);

const canNotifyReviewPeriodStarted = ({ transaction, transitionName, recipientRole }) => {
  if (
    !isBookingReviewProcess(transaction) ||
    !REVIEW_PERIOD_START_TRANSITIONS.has(transitionName)
  ) {
    return false;
  }

  // The poller loads the latest transaction. A delayed event must not request
  // another review from someone who has reviewed, or after the period expired.
  const latest = transaction?.attributes?.lastTransition;
  const otherRole = recipientRole === 'customer' ? 'provider' : 'customer';
  return (
    REVIEW_PERIOD_START_TRANSITIONS.has(latest) || latest === `transition/review-1-by-${otherRole}`
  );
};

const reviewPeriodNotificationDedupeKey = transactionId => `review-period-start:${transactionId}`;
const isReviewPeriodNotification = notification =>
  notification?.type === 'booking.updated' &&
  String(notification?.dedupeKey || '').startsWith('review-period-start:');

module.exports = {
  BOOKING_COMPLETION_TRANSITIONS,
  REVIEW_PERIOD_START_TRANSITIONS,
  isBookingReviewProcess,
  canNotifyReviewPeriodStarted,
  reviewPeriodNotificationDedupeKey,
  isReviewPeriodNotification,
};
